import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FeatureFlagService, FeatureFlagsServiceInjectionToken } from '@feature-flags/feature-flag.service';
import { combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const anyPaymentRunsTabEnabled: CanActivateFn = () => {
  const featureFlags = inject<FeatureFlagService>(FeatureFlagsServiceInjectionToken);
  return combineLatest([featureFlags.getValue$<boolean>('payEmployees', false), featureFlags.getValue$<boolean>('payHmrc', false)]).pipe(
    take(1),
    map(([payEmployees, payHmrc]) => payEmployees || payHmrc)
  );
};
